/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'products': {
    width: 26,
    height: 28,
    viewBox: '0 0 26 28',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-products-a" transform="rotate(-75 14.6 10.696)" fill="#F5D78B"/><defs><path pid="0" id="svgicon-products-a" d="M0 0l22 20H0V0z"/></defs>`
  }
})
